<script setup lang="ts">
import { useSlots } from 'vue';

const slots = useSlots();

const props = withDefaults(
  defineProps<{
    right?: string;
    left?: string;
    fontSizeClass?: string;
    backgroundColor?: string;
    textColor?: string;
  }>(),
  {
    right: '-0.25rem',
    left: 'auto',
    fontSizeClass: 'text-xs',
    backgroundColor: 'var(--tml-pip-background-color)',
    textColor: 'var(--tml-pip-text-color)',
  },
);
</script>

<template>
  <div class="relative">
    <slot />
    <div
      v-if="slots.pip"
      class="absolute -top-1 flex justify-center px-[0.4em] min-w-[1em] min-h-[1em] rounded-full leading-tight drop-shadow-lg"
      :class="props.fontSizeClass"
      :style="{ right, left, backgroundColor: props.backgroundColor, color: props.textColor }"
    >
      <slot name="pip" />
    </div>
  </div>
</template>
